export class BasicObject {
  id!: number;
  code!: string;
  label!: string;

  constructor(data: unknown = {}) {
    Object.assign(this, data);
  }
}
